import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

//MUI stuff
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";
import { TextField, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { validateEmail } from "../../utils/utilityFunctions";
import axios from "axios";

import { updateUserCredentials } from "../../redux/actions/userActions";

const useStyles = makeStyles()((theme) => ({
  parentDiv: {
    position: "fixed",
    bottom: 12,
    left: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    overflowY: "hidden",
    overflowX: "hidden",
    backgroundColor: "#e8e8e8",
    padding: theme.spacing(1),
    borderRadius: 5,
    [theme.breakpoints.down(440)]: {
      flexDirection: "column",
    },
    maxWidth: 202,
    zIndex: 1,
  },
  text: {
    fontSize: 15,
  },
  buttonsDiv: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 10,
    justifyContent: "flex-end",
    width: "100%",
  },
}));

export const CookiesConsent = (props) => {
  const { classes } = useStyles();

  const [showCookiesConsent, setShowCookiesConsent] = useState(false);

  useEffect(() => {
    // Hide cookies if we have a response value
    if (
      props.user.credentials.cookiesConsent ||
      localStorage.getItem("cookiesConsent")
    ) {
      setShowCookiesConsent(false);
    } else {
      // Show cookies consent immediately if no consent has been given
      setShowCookiesConsent(true);
    }
  }, [props.user.credentials.cookiesConsent]);

  const handleDeny = () => {
    localStorage.setItem("cookiesConsent", false);
    setShowCookiesConsent(false);

    if (props.user.authenticated) {
      axios
        .post("/api/user/cookiesConsent", { cookiesConsent: false })
        .then(() => {
          props.updateUserCredentials({ cookiesConsent: false });
        })
        .catch((err) => [console.log(err)]);
    }
  };

  const handleConsent = () => {
    localStorage.setItem("cookiesConsent", true);
    setShowCookiesConsent(false);

    if (props.user.authenticated) {
      axios
        .post("/api/user/cookiesConsent", { cookiesConsent: true })
        .then(() => {
          props.updateUserCredentials({ cookiesConsent: true });
        })
        .catch((err) => [console.log(err)]);
    }
  };

  return (
    <div>
      {showCookiesConsent ? (
        <div className={classes.parentDiv}>
          <Typography className={classes.text}>
            We use some cookies to personalise your experience as per our{" "}
            <Link
              href="/privacy-policy"
              onClick={(e) => e.preventDefault()}
              color="primary"
              underline="hover"
            >
              cookies policy.
            </Link>
          </Typography>
          <div className={classes.buttonsDiv}>
            <Button onClick={handleDeny} color="primary">
              Deny
            </Button>
            <Button onClick={handleConsent} color="primary" variant="contained">
              Accept
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

CookiesConsent.propTypes = {
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = { updateUserCredentials };

export default connect(mapStateToProps, mapDispatchToProps)(CookiesConsent);
